import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as JuglLogoIcon } from "./assets/jugl-logo.svg";

export const ChatFooter: FC = () => {
  return (
    <div className="flex shrink-0 justify-center bg-white py-2.5">
      <a
        href="https://jugl.com"
        target="_blank"
        rel="noopener noreferrer"
        className={cx(
          "text-grey-700 inline-flex items-center gap-[3px] no-underline transition-colors hover:text-[#2F80ED]",
          "border-b-1 -mb-px border-l-0 border-r-0 border-t-0 border-b border-solid border-transparent hover:border-b-[#2F80ED]"
        )}
      >
        <span className="font-secondary text-xs leading-[1.5]">Powered by</span>
        <JuglLogoIcon />
      </a>
    </div>
  );
};
